import React from 'react';
import { Modal, Form, Button, Row, Col, InputGroup } from 'react-bootstrap';
import { FaTrash, FaPlus } from 'react-icons/fa';

export const ModBomModal = ({
  show,
  onHide,
  currentModifierForBom,
  modBomItems,
  inventoryItems,
  handleAddModBomItemRow,
  handleModBomItemChange,
  handleRemoveModBomItemRow,
  handleModBomSubmit
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title style={{ color: "#1e3c72", fontWeight: 700 }}>
          Recipe for Choice: {currentModifierForBom?.name}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleModBomSubmit}>
        <Modal.Body>
          <Button variant="outline-primary" size="sm" onClick={handleAddModBomItemRow} className="mb-3">
            <FaPlus className="me-2" /> Add Ingredient
          </Button>
          
          {modBomItems.map((item, index) => (
            <Row key={index} className="align-items-center g-2 bg-light p-2 rounded mx-0 mb-2 shadow-sm">
              <Col xs={6}>
                <Form.Select required value={item.inventory_item_id} 
                  onChange={(e) => handleModBomItemChange(index, 'inventory_item_id', e.target.value)}
                >
                  <option value="">-- Select Item --</option>
                  {inventoryItems.map(inv => (
                    <option key={inv.id} value={inv.id}>{inv.name}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs={4}>
                <InputGroup>
                  <Form.Control type="number" step="0.01" min="0.01" required value={item.quantity} 
                    onChange={(e) => handleModBomItemChange(index, 'quantity', e.target.value)}
                  />
                  <InputGroup.Text>{item.unit || "-"}</InputGroup.Text>
                </InputGroup>
              </Col>
              <Col xs={2} className="text-end">
                <Button variant="outline-danger" size="sm" onClick={() => handleRemoveModBomItemRow(index)}>
                  <FaTrash />
                </Button>
              </Col>
            </Row>
          ))}
          {modBomItems.length === 0 && (
            <div className="text-center py-4 text-muted border rounded">No ingredients added yet.</div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="primary" type="submit" style={{ background: "#1e3c72" }}>Save Recipe</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
